/**
 * All supported viz types. (both primary and secondary viz types)
 */

/**
 * Only the primary viz types (i.e without data well)
 */

/**
 * Kind of is page level viz type, but is used in the index page.
 */

export const ALL_VIZ_TYPES = ['TABLE', 'BOARD', 'REPORT', 'GANTT_CHART', 'MAP', 'DATA_WELL'];
export const ALL_PAGE_TYPES = ['list', 'board', 'map', 'report', 'gantt'];
/**
 * Props passed to visualization settings components.
 * Settings components are responsible for rendering configuration UI.
 *
 * @template SType The type of the settings object for this visualization
 */

/**
 * A React component that renders the settings/configuration UI for a visualization.
 * This component allows users to configure how the visualization should render.
 *
 * @template SType The type of the settings object for this visualization
 */

/**
 * Props passed to the main visualization rendering component.
 *
 * @template SType The type of the settings object for this visualization
 */

/**
 * A React component that renders the actual visualization using the provided data and settings.
 * This is the main component that displays the chart, table, or other visual representation.
 *
 * @template SType The type of the settings object for this visualization
 */

/**
 * Registration object that defines all the components for a visualization type.
 * This is used by the visualization framework to register and render different visualizations.
 *
 * @template SType The type of the settings object for this visualization
 */

/**
 * Utility type to strip backend metadata from settings
 */

/**
 * Utility type to add backend metadata to settings
 */